<template>
  <div class="apply-refund" :class="{ isiOSX: isiOSX }">
    <van-nav-bar class="invest-title" :fixed="true" title="选择退股订单" />
    <img
      class="invest-reback"
      @click="prv"
      src="../../assets/myInvest/reback.png"
    />
    <div class="application">
      <van-row v-for="(item, index) in orders" :key="index">
        <van-col span="24" class="apply">
          <img
            @click="selected(item.id, index)"
            src="../../assets/myInvest/refund_n.png"
            class="select select_no"
            v-if="!item.selected"
          />
          <img
            src="../../assets/myInvest/refund_s.png"
            class="select select_s"
            v-if="item.selected"
          />
          <div class="apply_l">
            <img :src="picture" @error="nofind()" />
          </div>
          <div class="apply_r">
            <p class="apply_title">{{ title }}</p>
            <p class="apply_mun">
              退股数：<span class="detail">{{ item.shares }}股</span>
            </p>
            <p class="apply_mun margin-b">
              每股单价：<span class="detail">¥{{ unit_price }}</span>
            </p>
          </div>
        </van-col>
        <van-col span="24" class="refund refund1"
          >退还金额：<span class="refund_">¥{{ item.price[0] }}.</span
          ><span class="refund_0">{{ item.price[1] }}</span
          ><span>（原路退还）</span></van-col
        >
        <van-col span="24" class="refund refund2"
          >创建时间：<span>{{ item.created_at }}</span></van-col
        >
      </van-row>
    </div>
    <div class="confirm" @click="apply">确认</div>

    <van-row class="empty" v-if="orders.length == 0">
      <van-col class="emptyMsg" span="24">
        <img src="../../assets/myInvest/empty.png" />
        <p class="tip">暂无可退股订单</p>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import defaultImg from "@/assets/common/ListPreload.png";
export default {
  data() {
    return {
      picture: "",
      title: "",
      project_type: 0,
      orders: [],
      refundIds: [],
      created_at: "",
      numbers: 0,
      unit_price: 0,
      total_money: 0,
      isiOSX: false,
    };
  },
  created() {
    this.getInfo();
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    getInfo() {
      this.refundIds = [];
      this.total_money = 0;
      this.numbers = 0;
      this.$api
        .post("/investment/member/project/refund-orders", {
          project_id: this.$route.query.id,
        })
        .then((res) => {
          let flag = false;
          if (res.project.project_type == 1) {
            flag = true;
          }
          for (let i in res.orders) {
            if (i == 0) {
              this.unit_price = res.orders[i].price / res.orders[i].shares;
            }
            if (flag) {
              this.total_money += Number(res.orders[i].price);
              this.numbers += res.orders[i].shares;
              this.refundIds.push(res.orders[i].id);
              res.orders[i].selected = true;
            } else {
              res.orders[i].selected = false;
            }

            res.orders[i].price = this.tranform(res.orders[i].price);
          }
          this.picture = res.project.poster;
          this.title = res.project.project_name;
          this.project_type = res.project.project_type;
          this.orders = res.orders;
        });
    },
    selected(id, index) {
      if (this.project_type == 2) {
        this.refundIds = [id];
        for (let i in this.orders) {
          if (this.orders[i].id == id) {
            this.orders[i].selected = true;
            this.numbers = this.orders[i].shares;
            this.total_money = this.orders[i].price;
            this.created_at = this.orders[i].created_at;
          } else {
            this.orders[i].selected = false;
          }
        }
      }
    },
    apply() {
      if (this.project_type == 1) {
        this.total_money = this.tranform(this.total_money);
        if (this.orders.length == 1) {
          this.created_at = this.orders[0].created_at;
        }
      }
      if (this.refundIds[0]) {
        this.$router.replace({
          path: "/myInvest/application",
          query: {
            ids: this.refundIds,
            type: this.project_type,
            numbers: this.numbers,
            unit_price: this.unit_price,
            total_money: this.total_money,
            picture: this.picture,
            title: this.title,
            project_id: this.$route.query.id,
            created_at: this.created_at,
          },
        });
      } else {
        this.$toast("请选择您想要退股的订单");
      }
    },
    tranform(data) {
      if (data != null && data != 0) {
        data = Number(data).toFixed(2) + "";
        let arr = [data.split(".")[0], data.split(".")[1]];
        return arr;
      } else {
        return [0, "00"];
      }
    },
    prv() {
      this.$router.go(-1);
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
  },
};
</script>
<style lang="less" scoped>
.apply-refund {
  position: relative;
  min-height: 100%;
  background-color: #fff;
  .invest {
    &-title {
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 29px;
      left: 0;
      z-index: 1;
    }
  }
  .application {
    padding: 69px 16px 50px;
    background-color: #fff;
    .apply {
      display: flex;
      margin-top: 16px;
      padding-left: 32px;
      position: relative;
      .select {
        width: 16px;
        position: absolute;
        top: 30px;
        left: 0;
      }
      .apply_l {
        width: 100px;
        background: #f5f5f5;
        img {
          width: 100%;
          height: 100%;
          border-radius: 3px;
        }
      }
      .apply_r {
        padding-left: 12px;
        .apply_title {
          font-size: 16px;
          color: #333333;
          font-weight: 500;
          line-height: 24px;
          margin-bottom: 10px;
        }
        .apply_mun {
          font-size: 13px;
          color: #999999;
          line-height: 17px;
          font-weight: 400;
          margin-bottom: 7px;
          .detail {
            color: #d29a6e;
          }
        }
        .margin-b {
          margin-bottom: 0px;
        }
      }
    }
    .refund {
      padding: 12px 0 12px 32px;
      font-size: 13px;
      color: #999999;
      line-height: 22px;
      border-bottom: 1px solid #eeeeee;
      .refund_ {
        font-size: 16px;
        color: #d29a6e;
      }
      .refund_0 {
        font-size: 12px;
        color: #d29a6e;
      }
    }
    .refund1 {
      padding-bottom: 0;
      border-bottom: none;
    }
    .refund2 {
      padding-top: 4px;
    }
  }
  .confirm {
    position: fixed;
    bottom: 0;
    width: 100%;
    font-size: 16px;
    line-height: 49px;
    background-color: #c49e80;
    color: #fff;
    font-weight: 500;
    text-align: center;
  }
  .empty {
    padding-top: 100px;
    .emptyMsg {
      text-align: center;
      img {
        width: 106px;
        display: inline-block;
      }
      .tip {
        color: #cccccc;
        font-size: 14px;
        margin-top: 17px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
}
.isiOSX {
  .invest {
    &-title {
      padding-top: 44px;
    }
    &-reback {
      top: 45px;
    }
  }
  .application {
    padding-top: 88px;
  }
}
</style>


